export function autoRem($arg) {
    return `${($arg * 0.9).toFixed(2)}rem`;
}